export default __webpack_public_path__ + "static/media/ReBuyLogoBig.622d8ddc.png";